import { motion } from "framer-motion";
import { EASE, useSafeInView } from "@/components/Reveal";

const NODES = [
  { x: 150, y: 110, n: "01", name: "Context Graph", sub: "structure" },
  { x: 470, y: 110, n: "02", name: "Correlation Engine", sub: "relationships" },
  { x: 790, y: 110, n: "03", name: "Change Observability", sub: "drift" },
];

export default function SystemDiagram() {
  const [ref, show] = useSafeInView();
  return (
    <div ref={ref} className="min-w-[680px]">
      <svg viewBox="0 0 940 280" className="h-auto w-full" data-testid="diagram-connected-system">
        <defs>
          <marker id="sys-arrow" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse">
            <path d="M 0 1 L 9 5 L 0 9" fill="none" stroke="rgba(255,255,255,0.5)" strokeWidth="1.4" />
          </marker>
          <marker id="sys-arrow-teal" viewBox="0 0 10 10" refX="9" refY="5" markerWidth="7" markerHeight="7" orient="auto-start-reverse">
            <path d="M 0 1 L 9 5 L 0 9" fill="none" stroke="#00C0C8" strokeWidth="1.4" />
          </marker>
        </defs>

        <motion.line x1="196" y1="110" x2="424" y2="110" stroke="rgba(255,255,255,0.35)" strokeWidth="1.2" markerEnd="url(#sys-arrow)"
          initial={{ pathLength: 0 }} animate={show ? { pathLength: 1 } : {}}
          transition={{ duration: 0.9, ease: EASE, delay: 0.6 }} />
        <motion.line x1="516" y1="110" x2="744" y2="110" stroke="rgba(255,255,255,0.35)" strokeWidth="1.2" markerEnd="url(#sys-arrow)"
          initial={{ pathLength: 0 }} animate={show ? { pathLength: 1 } : {}}
          transition={{ duration: 0.9, ease: EASE, delay: 0.9 }} />
        <motion.path d="M 790 156 C 790 236, 150 236, 150 156" fill="none" stroke="#00C0C8" strokeWidth="1.2" strokeOpacity="0.7" markerEnd="url(#sys-arrow-teal)"
          initial={{ pathLength: 0 }} animate={show ? { pathLength: 1 } : {}}
          transition={{ duration: 1.4, ease: EASE, delay: 1.3 }} />

        <circle r="3.5" fill="#00C0C8">
          <animateMotion dur="2.8s" repeatCount="indefinite" path="M 196 110 L 424 110" />
        </circle>
        <circle r="3.5" fill="#00C0C8">
          <animateMotion dur="2.8s" begin="0.9s" repeatCount="indefinite" path="M 516 110 L 744 110" />
        </circle>
        <circle r="3.5" fill="#00C0C8" fillOpacity="0.85">
          <animateMotion dur="4.5s" begin="1.6s" repeatCount="indefinite" path="M 790 156 C 790 236, 150 236, 150 156" />
        </circle>

        {NODES.map((nd, i) => (
          <motion.g key={nd.n}
            initial={{ opacity: 0, y: 14 }}
            animate={show ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.8, ease: EASE, delay: i * 0.25 }}
          >
            <rect x={nd.x - 46} y={nd.y - 46} width="92" height="92" fill="#0C0C0C" stroke="rgba(255,255,255,0.18)" />
            <rect x={nd.x - 46} y={nd.y - 46} width="92" height="92" fill="none" stroke="#00C0C8" strokeOpacity="0.35" strokeDasharray="30 246">
              <animate attributeName="stroke-dashoffset" from="276" to="0" dur={`${5 + i}s`} repeatCount="indefinite" />
            </rect>
            <text x={nd.x} y={nd.y - 14} textAnchor="middle" fill="#00C0C8" fontSize="11" fontFamily="'JetBrains Mono', monospace">{nd.n}</text>
            <text x={nd.x} y={nd.y + 8} textAnchor="middle" fill="#FFFFFF" fontSize="12.5" fontWeight="500" fontFamily="'Outfit', sans-serif">
              {nd.name.split(" ")[0]}
            </text>
            <text x={nd.x} y={nd.y + 24} textAnchor="middle" fill="#FFFFFF" fontSize="12.5" fontWeight="500" fontFamily="'Outfit', sans-serif">
              {nd.name.split(" ").slice(1).join(" ")}
            </text>
            <text x={nd.x} y={nd.y - 60} textAnchor="middle" fill="rgba(255,255,255,0.35)" fontSize="10" fontFamily="'JetBrains Mono', monospace" letterSpacing="2">
              {nd.sub.toUpperCase()}
            </text>
          </motion.g>
        ))}

        <motion.text x="470" y="262" textAnchor="middle" fill="rgba(0,192,200,0.75)" fontSize="10" fontFamily="'JetBrains Mono', monospace" letterSpacing="2"
          initial={{ opacity: 0 }} animate={show ? { opacity: 1 } : {}}
          transition={{ duration: 0.8, delay: 2.2 }}>
          DRIFT SIGNALS KEEP THE GRAPH CURRENT
        </motion.text>
      </svg>
    </div>
  );
}
